<p-tree [value]="accounts" selectionMode='checkbox' [style]="style" [virtualScroll]="true" [virtualNodeHeight]="35"
[filter]="filter" [filterPlaceholder]="filterPlaceholder" [scrollHeight]="scrollHeight" [filterBy]="filterBy"
 [styleClass]="styleClass" (selectionChange)="onSelectionChange($event)" [trackBy]="trackBy" [emptyMessage]="emptyMessage"
[selection]="selected"
>
<ng-template let-node pTemplate="account">
  <span class="first-label head-width" ellipsis>{{node.accountName}}</span> <span style="position: absolute;">{{getContactCounts(node)}}</span>
</ng-template>
<ng-template let-node pTemplate="contact">
  <div style="position: relative;padding-right: 20px;line-height: 1.3;font-size: 14px;" [ngClass]="{disabled:node.selectable===false}" >
    <i class="fa fa-asterisk" aria-hidden="true" style="position: absolute;right:0;top:2px;" *ngIf="node.isPrimary" ></i>
    <div class="first-label">{{node?.contactName}}</div>
    <div class="secondary-label">{{node?.contactEmail}}</div>
  </div>
</ng-template>
</p-tree>
